/**
 * Created by Ivan on 07.07.2026
 */

const StickersShopWindow = Prefab.createWindow("stickers_shop", "stickers_shop_window_prefab_json");
